export default function PrivacyPolicy() {
  const styles = {
    page: {
      minHeight: "100vh",
      background: "#f6f7f9",
      padding: "120px 16px 64px", // evita que el header lo tape
    },
    container: {
      maxWidth: 980,
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: 18,
      border: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 18px 45px rgba(0,0,0,0.06)",
      overflow: "hidden",
    },
    header: {
      padding: "28px 28px 18px",
      borderBottom: "1px solid rgba(0,0,0,0.06)",
    },
    eyebrow: {
      margin: "0 0 6px",
      fontSize: 12,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      opacity: 0.7,
    },
    title: {
      margin: "0 0 8px",
      fontSize: 30,
      lineHeight: 1.15,
      letterSpacing: "-0.02em",
    },
    subtitle: {
      margin: 0,
      fontSize: 15,
      opacity: 0.75,
    },
    body: {
      padding: "22px 28px 28px",
      fontSize: 16,
      lineHeight: 1.75,
      color: "#1b1f24",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
    },
    h2: {
      margin: "22px 0 10px",
      fontSize: 18,
      lineHeight: 1.3,
    },
    p: {
      margin: "0 0 14px",
    },
    ul: {
      margin: "0 0 14px 18px",
      padding: 0,
    },
    li: {
      margin: "0 0 8px",
    },
    footer: {
      marginTop: 18,
      paddingTop: 14,
      borderTop: "1px solid rgba(0,0,0,0.06)",
      fontSize: 13,
      opacity: 0.75,
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.card}>
          <header style={styles.header}>
            <h1 style={styles.title}>Política de Privacidad</h1>
            <p style={styles.subtitle}>Cómo usamos y protegemos tu información.</p>
          </header>

          <div style={styles.body}>
            <p style={styles.p}>
              En <strong>AdAstra</strong>, respetamos y protegemos la privacidad de nuestros
              clientes y usuarios. Esta política explica cómo recopilamos, usamos y
              protegemos tu información.
            </p>

            <h2 style={styles.h2}>1. Información que recopilamos</h2>
            <p style={styles.p}>
              La información recopilada a través de anuncios, mensajes o formularios puede
              incluir datos proporcionados voluntariamente por el usuario.
            </p>

            <h2 style={styles.h2}>2. Uso de la información</h2>
            <ul style={styles.ul}>
              <li style={styles.li}>Responder consultas y solicitudes de información</li>
              <li style={styles.li}>Brindar asesoría sobre nuestros productos</li>
              <li style={styles.li}>Gestionar pedidos, entregas y atención al cliente</li>
              <li style={styles.li}>Enviar información promocional cuando el usuario lo autorice</li>
            </ul>

            <h2 style={styles.h2}>3. Compartición con terceros</h2>
            <p style={styles.p}>
              AdAstra no vende, alquila ni comparte información personal con terceros, salvo
              cuando sea necesario para completar un pedido o cumplir con obligaciones legales.
            </p>

            <h2 style={styles.h2}>4. Derechos del usuario</h2>
            <p style={styles.p}>
              Podés solicitar la actualización o eliminación de tu información escribiéndonos
              a nuestro Instagram oficial: <strong>@adastra.cr</strong>.
            </p>

            <div style={styles.footer}>
              Última actualización: diciembre de 2025.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
